import { HStack, InputProps, Radio, RadioGroup, RadioProps, Text } from "@chakra-ui/react";
import { FormikValues, useFormikContext } from "formik";

function RadioField<Value extends FormikValues>({
  name,
  options,
  color,
}: {
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  [key: string]: unknown;
  color?: InputProps['color'];
}) {
  const { values, setFieldValue } = useFormikContext<Value>();
  return (
    <RadioGroup
      onChange={(dvalues) => {
        setFieldValue(name, dvalues);
      }}
      value={values[name]}
    >
      <HStack gap="6">
        {options.map((item) => (
          <Radio
            name={name}
            value={item.value}
            size="sm"
            key={item.value}
            colorScheme="blue"
          >
            <Text fontSize="13px" fontWeight="500" color={color ?? '#5B6573'}>
              {item.label}
            </Text>
          </Radio>
        ))}
      </HStack>
    </RadioGroup>
  );
}

export default RadioField;
